import axios from 'axios';
import { defineStore } from 'pinia';
import { saveAs } from 'file-saver';

export const useDataStore = defineStore('data', {

  state: () => ({
    allfiles: [],
    oneFileSelected: false,
    fileNamesWith_WithoutID: [],
    isSaveBTNclickedonce: false,
    downloadBTNclicked: false,
    changeFileSelection: '',
    resetValue: 'RESET FILES',
    recordsAnalyzed: 0,
    amountOfBusinesscases: 0,
    amountOfBusinesspositions: 0,
    enableBTN: false,
    dropfiles: true,
    maxTraTimeSec: '',
    hovered: false,
    totalAmount: 0,
    journalErrorcount: 0,
    logErrorcount: 0,
    activeTab: '',
    recordtypesopen: false,
    businesscaseopen: false,
    businesspositionopen: false,
    auditopen: false,
    cmpopen: false,
    locopen: false,
    trmopen: false,
    devopen: false,
    totalsopen: false,
    result: {},
    openedJouErrors: [],
    openedLogErrors: [],
    jouErrors: {},
    logErrors: {},
    Audits: {},
    businessCases: {},
    businessPosition: {},
    recordCounts: {},
    cmp: {},
    loc: {},
    trm: {},
    dev: {},
    totals: {
      T: 0, TotalNet: 0, TotalAmt: 0, TotalTAmt: 0,
      FiscalAmount: 0, NonFiscalAmount: 0, VoidAmount: 0, RefundAmount: 0,
      InvoiceAmount: 0, EInvoiceAmount: 0, EInvoiceCount: 0, PayGroups: {}
    },
    taxGroups: [],
    versions: [],
    responseTimes: [],
    amountofRecords: 0,
    amountofBC: 0,
    amountofBP: 0,
    amountOfAudits: 0,
    amountOfCmp: 0,
    amountOfLoc: 0,
    amountOfTrm: 0,
    amountOfDev: 0,
    contents: [],
    versionbool: false,
    taxbool: false,
    error: '',
    isModalVisible: false,
    isLoading: false,
    isUploading: false,
    isAnalyzing: false,
    progressAnalyzing: 0,
    progressText: '',
    modalTitle: '',
    modalBody: '',
    modalConfirmAction: null,
    modalCancelAction: null,
    hasCancelButton: true,
    totalFiles: 0,
    analyzedFiles: 0,
    errorCount: 0,
    warningCount: 0,
    oversizedFiles: [],
    invalidLogFileName: [],
  }),
  getters: {
    oversizedList(state) {
      const names = state.oversizedFiles
      if (names.length === 0) return ''
      if (names.length === 1) return names[0]
      return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
    },
    invalidLogFileNameList(state) {
      const names = state.invalidLogFileName
      if (names.length === 0) return ''
      if (names.length === 1) return names[0]
      return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
    }
  },
  actions: {
    showModal(title, body, confirmAction = null, cancelAction = null, hasCancelButton = true) {
      this.modalTitle = title;
      this.modalBody = body;
      this.modalConfirmAction = confirmAction;
      this.modalCancelAction = cancelAction;
      this.isModalVisible = true;
      this.hasCancelButton = hasCancelButton;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    confirmModalAction() {
      if (this.modalConfirmAction) {
        this.modalConfirmAction();
      }
      this.closeModal();
    },

    cancelModalAction() {
      if (this.modalCancelAction) {
        this.modalCancelAction();
      }
      this.closeModal();
    },

    setError(message) {
      this.error = message;
    },
    clearError() {
      this.error = '';
      this.oversizedFiles = [];
      this.invalidLogFileName = [];
    },
    /**
    * Handles drag and drop
    *
    * @function handleDrop
    * @param {Event} event - The drop event containing the files.
    */
    handleDrop(event) {
      const files = event.dataTransfer.files;
      this.mergeFiles(files);
    },
    /**
    * Handles selected files
    *
    * @function handleDrop
    * @param {Event} event - The click event containing the files.
    */
    handleClick(event) {
      const files = event.target.files;
      this.mergeFiles(files);
    },
    /**
     * 
     * Checks if the dropped file has a .log, .jou, .json, .zip, .gz or e.log extension. If valid, assigns the first file to `file`,
     * logs the file name, adds it to `allfiles`, and enables the button.
     * If the file type is invalid, an alert is shown.
     * @param {files} files 
     */
    mergeFiles(files) {
      for (const file of files) {
        let surchallowness = true;
        this.contents.forEach(contentobj => {
          if (file.name == contentobj.name) {
            alert("File already used");
            surchallowness = false;
          }
        });
        if (surchallowness) {
          if (!file.name.endsWith('.log') && !file.name.endsWith('.jou') && !file.name.endsWith(".json") && !file.name.endsWith(".zip") && !file.name.endsWith("e.log")) {
            this.showModal(
              'Wrong file type',
              'Please choose a file of type .log, e.log, .jou, .json, .zip ',
              this.closeModal,
              null,
              false
            );
            // alert('Bitte wählen Sie eine .log, .jou, .json, .zip oder e.log Datei aus');
          } else {
            let isuniq = true;
            const reader = new FileReader();
            reader.onload = (e) => {
              const content = e.target.result;
              this.contents.forEach(contententry => {
                if (content == contententry.content) {
                  isuniq = false;
                }
              });
              if (isuniq) {
                this.contents.push({
                  content: content,
                  name: file.name
                });
                this.file = file;
                //console.log(`Dropped file: ${this.file.name}`);
                // this.allfiles.push({
                //   name: file,
                //   hovered: false
                // });
                this.allfiles.push(file);
                this.enableBTN = true;
              } else {
                alert('Ident File as' + e.target.name);
              }
            };
            reader.readAsText(file);
          }
        }
      }
    },

    getBaseUrl() {
      // The SPA is served by nginx (the `web` container), which reverse-proxies
      // /api to the internal Functions container. So the API is reached via a
      // relative path, same-origin. For local dev, run `func start` and proxy
      // /api to http://localhost:7071/api.
      return "/api";

      // if (document.location.hostname === "localhost")
      //   return "http://localhost:7071/api";
      // return "https://efranalyzer.azurewebsites.net/api";
    },

    /**
    * Asynchronously uploads files, analyzes them, and updates the file list.
    *
    * Sets `isSaveBTNclickedonce` to true and activates the 'journal' tab.
    * Iterates over `allfiles`, creates FormData for each file, and uploads it.
    * On success, logs the message, analyzes the file, and updates `fileNamesWith_WithoutID`.
    * On failure, logs the error and updates a reference with an error message.
    * Finally, updates the file data.
    *
    * @async
    * @function saveFile
    */
    async saveFile() {
      this.isLoading = true;
      this.isUploading = true;
      this.progressText = "Uploading files ...";
      this.progressUploading = 0;
      this.oversizedFiles = [];
      this.invalidLogFileName = [];

      const formData = new FormData();
      for (let i = 0; i < this.allfiles.length; i++) {
        formData.append("file" + i, this.allfiles[i]);
      }

      try {
        const response = await axios.post(this.getBaseUrl() + '/uploadFiles', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        //console.log('Uploading files successfully: ', response.data);
        this.isUploading = false;
        if (response.data && Array.isArray(response.data.filenames)) {
          this.allfiles = response.data.filenames.map(filename => ({ name: filename, hovered: false }));

          for (const filename of response.data.filenames) {
            await this.analyzeFile(filename);
            this.fileNamesWith_WithoutID.push({
              nameId: filename
            })
          }
        }
      } catch (err) {
        if (err.response && err.response.status === 422 && err.response.data) {
          const { invalidLogFileNames } = err.response.data;
          
          if (invalidLogFileNames && invalidLogFileNames.length > 0) {
            this.invalidLogFileName.push(...invalidLogFileNames);
            this.error = 'Invalid log file name error';
          }
        } else if (err.response && err.response.status === 413 && err.response.data) {
          const { oversizedFiles } = err.response.data;

          if (oversizedFiles && oversizedFiles.length > 0) {
            this.oversizedFiles.push(...oversizedFiles);
            this.error = 'File size error';
          }
        } else if (err.response && err.response.data) {
          // Handle other specific errors
          this.error = err.response.data;
        } else {
          // Handle generic network errors
          this.error = err.toString();
        }

        console.error('Error uploading file:', err);
        this.isLoading = false;
      }

      this.setData(this.fileNamesWith_WithoutID);
      this.isSaveBTNclickedonce = true;
      this.progressText = '';
      this.isLoading = false;
      this.activeTab = 'journal';
    },

    /**
    * Asynchronously analyzes a file by its filename and updates the results.
    *
    * If no filename is provided, logs an error and updates a reference with an error message.
    * Sends a POST request to analyze the file. On success, logs the response and stores the result.
    * On failure, logs the error and updates a reference with an error message.
    *
    * @async
    * @function analyzeFile
    * @param {string} filename - The name of the file to analyze.
    */
    async analyzeFile(filename) {
      this.isAnalyzing = true;

      if (!filename) {
        //console.log("No file to analyze");
        this.error = 'No file to analyze!';
        return;
      }

      // FOR TEST PURPOSE ONLY
      // if (filename) this.error = 'No file to analyze!';

      try {
        this.progressText = "Analyzing files ...";
        this.totalFiles = this.allfiles.length;
        this.analyzedFiles = Object.keys(this.result).length + 1;

        const maxTraTime = (() => {
          const value = parseInt(this.maxTraTimeSec, 10);
          return Number.isFinite(value) && value > 0 ? value : 10;
        })();

        const response = await axios.post(`${this.getBaseUrl()}/analyzeFiles?file=${filename}&maxTraTime=${maxTraTime}`);
        const output = response.data.result;
        this.result[filename] = output;

        this.progressAnalyzing = Math.round((this.analyzedFiles / this.totalFiles) * 100);
        if (this.progressAnalyzing >= this.totalFiles) {
          this.isLoading = false;
          this.progressText = '';
        }
      } catch (error) {
        console.error('Error analyzing file:', error);
        this.error = 'Error analyzing file!';
      }

      this.isAnalyzing = false;
    },
    /** 
     * downloads a journal File with the final results in it 
     * @function downloadFile
     */
    downloadFile() {
      var blob = new Blob([JSON.stringify(this.result)], { type: "text/plain;charset=utf-8" });
      saveAs(blob, "result.jou");
      this.downloadBTNclicked = true;
    },

    /**
     * this function regulates what data is shown in the ResulView
     * @param {*} filenames the parameter is an array filled with objects, which have the filename and the ID of the Files.
     * The ResultView shows the data of those ID's.
     */
    setData(filenames) {
      this.jouErrors = {};
      this.logErrors = {};
      this.Audits = {};
      this.businessCases = {};
      this.businessPosition = {};
      this.recordCounts = {};
      this.taxGroups = [];
      this.amountofRecords = 0;
      this.amountofBC = 0;
      this.amountofBP = 0;
      this.amountOfAudits = 0;
      this.amountOfCmp = 0;
      this.amountOfLoc = 0;
      this.amountOfTrm = 0;
      this.amountOfDev = 0;
      this.versions = [];
      this.responseTimes= [];
      this.totals = {
        T: 0, TotalNet: 0, TotalAmt: 0, TotalTAmt: 0,
        FiscalAmount: 0, NonFiscalAmount: 0, VoidAmount: 0, RefundAmount: 0,
        InvoiceAmount: 0, EInvoiceAmount: 0, EInvoiceCount: 0, PayGroups: {}
      };
      let total = 0;
      let journal = 0;
      let logs = 0;
      this.versionbool = false;
      this.taxbool = false;
      this.errorCount = 0;
      this.warningCount = 0;
      const businessCaseNames = ["Void", "Z", "X", "Training", "NonFiscalInvoice", "FiscalInvoice", "Abort", "Order", "OpeningBalance", "DepositOfChange", "DailyClosureCashout", "PayIn", "PayOut", "Reprint", "Login", "Logout", "ProformaInvoice", "NonFiscal", "Sale"]

      const initializeBusinessCases = () => {
        businessCaseNames.forEach(caseName => {
          if (!this.businessCases[caseName]) {
              this.businessCases[caseName] = { a: 0, e: 0, w: 0 };
          }
        });
      };
      initializeBusinessCases();

      // for each file the data will be saved in the variables above
      filenames.forEach(fileobj => {
        if (!this.result[fileobj.nameId]) return;
        let output = null;
        try {
          output = JSON.parse(JSON.stringify(this.result[fileobj.nameId]));
        } catch (error) {
          console.error(error);
        }

        // log files
        if (fileobj.nameId.endsWith('.log')) {
          // sets data for Log Analyses in ResultView
          for (let error in output.ErrorCodes) {
            logs += output.ErrorCodes[error].length;
            if (this.logErrors[error]) {
              output.ErrorCodes[error].forEach(detail => {
                this.logErrors[error].push(detail);
              });
            } else {
              this.logErrors[error] = output.ErrorCodes[error];
            }
          }

          if (output.TraTimes && !fileobj.nameId.startsWith('elog')) {
            const tra = output.TraTimes;
            const exceeded = Array.isArray(tra.ExceededThreshold) ? tra.ExceededThreshold : [];
            const unresolved = tra.UnresolvedCheckins
              ? Object.values(tra.UnresolvedCheckins).reduce((sum, n) => sum + Number(n || 0), 0)
              : 0;
            
            this.responseTimes.push({
              key: fileobj.nameId,
              data: {
                day: tra.Day,
                avgMs: Number(tra.AvgPerDay?.AvgTime ?? 0),
                topTenAvgMs: Number(tra.AvgPerDay?.TopTen?.AvgTime ?? 0),
                topTenLines: tra.AvgPerDay?.TopTen?.Lines ?? [],
                avgPerType: tra.AvgPerType ?? {},
                unresolvedCount: unresolved,
                unresolvedByType: tra.UnresolvedCheckins ?? {},
                exceededCount: exceeded.length,
                exceededLines: exceeded
              }
            });
          }

          // sets data for Version History in ResultView  
          output.VersionUpdates.forEach(version => {
            this.versions.push(version);
          });

          if (this.versions.length > 0) this.versionbool = true;
        }
        // journal and json files
        else if (fileobj.nameId.endsWith('.jou') || fileobj.nameId.endsWith('.json')) {
          // const output = JSON.parse(JSON.stringify(this.result[fileobj.nameId]));

          // sets data for TaxGroups in ResultView
          for (let i = 0; i < output.Totals.Taxes.length; i++) {
            let inArr = false;
            for (let j = 0; j < this.taxGroups.length; j++) {
              if (output.Totals.Taxes[i].TaxG == this.taxGroups[j].TaxG) {
                this.taxGroups[j].Net += output.Totals.Taxes[i].Net;
                this.taxGroups[j].TAmt += output.Totals.Taxes[i].TAmt;
                this.taxGroups[j].Amt += output.Totals.Taxes[i].Amt;
                inArr = true;
                j = this.taxGroups.length;
              }
            }
            if (this.taxGroups.length > 0) this.taxbool = true;
            if (!inArr) {
              this.taxGroups.push(output.Totals.Taxes[i]);
            }
          }

          // sets data for Business Cases in ResultView
          this.amountOfCmp += output.RecordTypeCounter.CfgCmp;
          this.amountOfLoc += output.RecordTypeCounter.CfgLoc;
          this.amountOfTrm += output.RecordTypeCounter.CfgTrm;
          this.amountOfDev += output.RecordTypeCounter.CfgDev;
          this.cmp = output.Cfg.Cmp;
          this.loc = output.Cfg.Loc;
          this.trm = output.Cfg.Trm;
          this.dev = output.Cfg.Dev;
          this.errorCount = output.Business_Cases.ErrorCount;
          this.warningCount = output.Business_Cases.WarningCount;

          for (let record in output.RecordTypeCounter) {
            if (record == "Cfg") {
              this.recordCounts[record] = this.amountOfCmp + this.amountOfLoc + this.amountOfTrm + this.amountOfDev
            } else {
              this.amountofRecords += output.RecordTypeCounter[record];
              if (this.recordCounts[record]) {
                this.recordCounts[record] += Number(output.RecordTypeCounter[record]);
              } else {
                this.recordCounts[record] = Number(output.RecordTypeCounter[record]);
              }
            }
          }

          for (let bcase in output.Business_Cases) {
            try {
              if (bcase === "ErrorCount" || bcase === "WarningCount") continue;
              const bcaseData = output.Business_Cases[bcase];
            
              if (!this.businessCases[bcase]) { this.businessCases[bcase] = { a: 0, e: 0, w: 0 }; }
              if (typeof bcaseData === "object") {
                const total = bcaseData.a || 0;
                const errors = bcaseData.e || 0;
                const warnings = bcaseData.w || 0;
                this.businessCases[bcase].a += total;
                this.businessCases[bcase].e += errors;
                this.businessCases[bcase].w += warnings;
                this.amountofBC += total; 
              } else {
                const total = bcaseData || 0;
                this.businessCases[bcase].a += total;
                this.amountofBC += total;
              }
            } catch (e) {
              console.error(e)
            }
          }

          for (let pos in output.Business_Position) {
            this.amountofBP += output.Business_Position[pos];
            if (this.businessPosition[pos]) {
              this.businessPosition[pos] += Number(output.Business_Position[pos]);
            } else {
              this.businessPosition[pos] = Number(output.Business_Position[pos]);
            }
          }

          for (let audit in output.Audits) {
            this.amountOfAudits += output.Audits[audit];
            if (this.Audits[audit]) {
              this.Audits[audit] += Number(output.Audits[audit]);
            } else {
              this.Audits[audit] = Number(output.Audits[audit]);
            }
          }

          // sets data for Journal Analysis in ResultView
          for (let error in output.ErrorCodes) {
            journal += output.ErrorCodes[error].length;
            if (this.jouErrors[error]) {
              output.ErrorCodes[error].forEach(detail => {
                this.jouErrors[error].push(detail);
              });
            } else {
              this.jouErrors[error] = output.ErrorCodes[error];
            }
          }
          total += Number(output.Totals.T);
          this.totals.T += Number(output.Totals.T) || 0;
          this.totals.TotalAmt += Number(output.Totals.TotalAmt) || 0;
          this.totals.TotalNet += Number(output.Totals.TotalNet) || 0;
          this.totals.TotalTAmt += Number(output.Totals.TotalTAmt) || 0;
          this.totals.FiscalAmount += Number(output.Totals.FiscalAmount) || 0;
          this.totals.NonFiscalAmount += Number(output.Totals.NonFiscalAmount) || 0;
          this.totals.VoidAmount += Number(output.Totals.VoidAmount) || 0;
          this.totals.RefundAmount += Number(output.Totals.RefundAmount) || 0;
          this.totals.InvoiceAmount += Number(output.Totals.InvoiceAmount) || 0;
          this.totals.EInvoiceAmount += Number(output.Totals.EInvoiceAmount) || 0;
          this.totals.EInvoiceCount += Number(output.Totals.EInvoiceCount) || 0;
          const payGroups = output.Totals.PayGroups || {};
          for (const group in payGroups) {
            this.totals.PayGroups[group] = (this.totals.PayGroups[group] || 0) + (Number(payGroups[group]) || 0);
          }
        }
      });

      // Fills the SummaryControl with data, but only if every file is selected
      if (filenames.length == this.fileNamesWith_WithoutID.length) {
        this.totalAmount = total;
        this.journalErrorcount = journal;
        this.recordsAnalyzed = this.amountofRecords;
        this.logErrorcount = logs;
      }
    },

    /**
     * This function is called when the user clicks on one of the listet previous files.
     * It selects the clicked file and calls setData(). The data of the selected file will be shown
     * @param {filename} filename object array with the selected filenames 
     */
    toggleFile(filename) {
      this.changeFileSelection = filename;
      let onefile = false;
      this.oneFileSelected = false;
      this.fileNamesWith_WithoutID.forEach(fileobj => {
        if (this.changeFileSelection == fileobj.nameId) {
          let arr = [fileobj];
          onefile = true;
          this.oneFileSelected = true;
          this.setData(arr);
          return;
        }
      });

      if (!onefile) this.setData(this.fileNamesWith_WithoutID);
    },
    /*
    This function toggles the presence of a main entry's error code in the openedJouErrors list,
    enabling show/hide functionality for error details.
    */
    clickJouEntry(entry) {
      if (!entry.main) return;
      let key = entry.errorCode;
      let i = this.openedJouErrors.indexOf(key);
      if (i > -1) {
        this.openedJouErrors.splice(i, 1);
      } else {
        this.openedJouErrors.push(key);
      }
    },
    /*
    This function toggles the presence of a main entry's error code in the openedLogErrors list,
    enabling show/hide functionality for error details.
    */
    clickLogEntry(entry) {
      if (!entry.main) return;
      let key = entry.errorCode;
      let i = this.openedLogErrors.indexOf(key);
      if (i > -1) {
        this.openedLogErrors.splice(i, 1);
      } else {
        this.openedLogErrors.push(key);
      }
    },
    reloadPage() {
      location.reload();
    },
    closeSession() {
      if (!this.downloadBTNclicked) {
        this.showModal(
          'Are you sure you want to reset the page?',
          'Your changes will not be saved.',
          this.closeModal,
          this.closeModal,
          true
        );
      } else {
        this.reloadPage();
      }
    }
  },
})